var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FullCalendar", {
    ref: "csm__project__calendar",
    attrs: {
      options: Object.assign({}, _vm.calendarOptions, {
        events: _vm.calendarEvents
      })
    },
    scopedSlots: _vm._u([
      {
        key: "eventContent",
        fn: function(arg) {
          return [
            typeof arg.event.extendedProps.deliverable != "undefined"
              ? _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      arg.event.extendedProps.deliverable +
                        " > " +
                        arg.event.title
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleEventTitleClick(arg)
                    }
                  }
                })
              : _c("span", {
                  domProps: { innerHTML: _vm._s(arg.event.title) },
                  on: {
                    click: function($event) {
                      return _vm.handleEventTitleClick(arg)
                    }
                  }
                })
          ]
        }
      },
      {
        key: "dayCellContent",
        fn: function(arg) {
          return [
            _c(
              "a",
              {
                staticClass: "fc-daygrid-day-number",
                attrs: {
                  id: "fc-dom-4",
                  "aria-label": _vm.$moment(arg.date).format("MMMM DD, YYYY")
                }
              },
              [_vm._v(_vm._s(arg.dayNumberText))]
            ),
            _vm._v(" "),
            _vm.$moment
              .utc(arg.date)
              .isSame(_vm.$moment.utc(_vm.expandDate), "day")
              ? _c(
                  "a",
                  {
                    staticClass: "fc-event-hide",
                    attrs: { title: "Collapse" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleHideClick(arg)
                      }
                    }
                  },
                  [_vm._v("Collapse")]
                )
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }